import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
 margin: theme.spacing(10, 0),
 [theme.breakpoints.down('md')]: {
   margin: theme.spacing(6, 0),
  },
'& .EInfoItem':{
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
},
'& .EInfoIcon':{
    width: theme.spacing(2.25),
    height: theme.spacing(2.25),
    position: 'relative',
    top:  theme.spacing(-0.25)
},
'& .EISDesc':{
  '& a':{
    color: theme.palette.common.white,
    textDecoration:'underline',
    fontWeight: 700,
  },
},
}));
export default StyledBox;